import { generateImagePath } from '@worldcoo/shared/utils';

export function generateImageSrc(
	src: string,
	opts?: { height?: number; width?: number; format?: 'webp' | 'avif'; quality?: number; resizeType?: 'fill' | 'fit' },
): string {
	if (!import.meta.env.VITE_IMGPROXY_URL) return src;

	return import.meta.env.VITE_IMGPROXY_URL + generateImagePath(src, opts);
}

export function buildPortalUrl(portalId: string): string {
	if (typeof window === 'undefined') return '';
	const { protocol, hostname, port } = window.location;
	const parts = hostname.split('.');
	parts[0] = portalId;
	const portSuffix = port ? `:${port}` : '';
	return `${protocol}//${parts.join('.')}${portSuffix}`;
}

export function getPortalDomainSuffix(): string {
	if (typeof window === 'undefined') return '';
	const { hostname, port } = window.location;
	const parts = hostname.split('.');
	const portSuffix = port ? `:${port}` : '';
	return `.${parts.slice(1).join('.')}${portSuffix}`;
}

export const getLogoImageSize = (portalId: string) => ({
	height:
		portalId === 'awwg'
			? 72
			: portalId === 'generaloptica'
				? 72
				: portalId === 'maxsupermercati'
					? 72
					: portalId === 'eroski'
						? 60
						: portalId === 'familasicilia'
							? 60
							: portalId === 'fundacionrealmadrid'
								? 60
								: portalId === 'portaventura'
									? 60
									: 50,
});
